import { useTheme, useMediaQuery, Box } from "@mui/material";
import AgentsDashboardMobile from "./AgentsDashboardMobile";
import AgentsDashboardDesktop from "./AgentsDashboardDesktop";

export default function AgentsDashboard() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      sx={{
        bgcolor: "background.default",
        color: "text.primary",
        minHeight: "100vh",
      }}
    >
      {isMobile ? <AgentsDashboardMobile /> : <AgentsDashboardDesktop />}
    </Box>
  );
}
